import React from 'react';
import { clsx } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import { useTextStyles } from './use-text-styles';
const headingResolver = {
  '1': {
    component: 'h1',
    textStyle: 'HEADING_1'
  },
  '2': {
    component: 'h2',
    textStyle: 'HEADING_2'
  },
  '3': {
    component: 'h3',
    textStyle: 'HEADING_3'
  },
  '4': {
    component: 'h4',
    textStyle: 'HEADING_4'
  }
}; // FIXME: Temporarily hard-code HeadingLevel as typescript@3.8.3+ introduced an issue whereby
// casting an object as const coerces keys that look like numbers to numbers even if they're explicitly
// declared as strings.
// Please update the HeadingLevel if you introduce additional heading types to headingResolver above.
// type HeadingLevel = keyof typeof headingResolver;

export const Heading = ({
  level,
  className: classNameProp,
  classes: classesProp,
  ...rest
}) => {
  const {
    component: Component,
    textStyle
  } = headingResolver[level];
  const isMobile = useMediaBreakpoint('TABLET_AND_BELOW');
  const classes = useTextStyles(classesProp, {
    textStyle,
    isMobile
  });
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Component, Object.assign({
    className: className
  }, rest));
};